//This component will  handle slider for Percentile/Absolute values
import React from "react";
import reqwest from "reqwest";
import "../css/Sliderlo.css";
import { Slider, Row, Col, Card, Select, Button, InputNumber ,Switch,Popover,Tooltip } from "antd";
import { connect } from "react-redux";
import { activateDatadic,activateDatadicbackup,activateFiname,activateChange,activateScreen,activateRecord,activatePath,activateGoing , activateUnivid,
  activateUnivtype, } from "../redux";
import { CloseCircleTwoTone, PoweroffOutlined,CloseOutlined, CheckOutlined  } from "@ant-design/icons";

const { Option } = Select;

class Sliderloclass extends React.Component {
  constructor(props) {
    super(props);
    this.myRef = React.createRef();
    this.myRef2 = React.createRef();
    
    this.state = {
      filtermt:this.props.filtermt,
      pass: this.props.pass,
      id: this.props.id,
      coltype:this.props.coltype,
      colNameId:this.props.colNameId,
      data: [],
      inputValue: 0,
      inputValue2: 0,
    };
    this.handleChange = this.handleChange.bind(this);
    this.onChange = this.onChange.bind(this);
    this.onChange2 = this.onChange2.bind(this);
    this.handleToggle = this.handleToggle.bind(this);
    this.HandleReqcount = this.HandleReqcount.bind(this);
  }
  
  handleToggle(a,e,id,arr=[]){
  
    this.props.activateChange(1);
   // this.HandleReqcount() 
    if (this.props.datadic.FilterDic != undefined) {
              this.props.datadic.FilterDic.columns.map((experience, i) => {

        
                          if (this.props.datadic.FilterDic.columns[i].colNameId == a && this.props.datadic.FilterDic.columns[i].selectedUI == 1) {
                               this.props.datadic.FilterDic.columns[i].selectedUI = 0;
                               this.props.datadic.FilterDic.columns[i].selected = 0;
                              
                               if(experience.typeCol.toLowerCase() =='absolute' && this.props.datadic.FilterDic.columns[i].value==''){
                                this.props.datadic.FilterDic.columns[i].value=[this.props.datadic.FilterDic.columns[i].min,this.props.datadic.FilterDic.columns[i].max];
                               }

                          
                        
                          }else if (this.props.datadic.FilterDic.columns[i].colNameId == a && this.props.datadic.FilterDic.columns[i].selectedUI == 0) {
                            this.props.datadic.FilterDic.columns[i].selectedUI = 1;
                            this.props.datadic.FilterDic.columns[i].selected = 1;
                            if(experience.typeCol.toLowerCase() =='absolute' && this.props.datadic.FilterDic.columns[i].value==''){
                              this.props.datadic.FilterDic.columns[i].value=[this.props.datadic.FilterDic.columns[i].min,this.props.datadic.FilterDic.columns[i].max];
                            }
                          }

                          
              });
           
    }  
  console.log('data',this.props.datadic.FilterDic)
   this.props.activateDatadic({ FilterDic: this.props.datadic.FilterDic });
   setTimeout(() =>  this.HandleReqcount(), 1*1000);
  }



  handleChange(e) {
   
    this.props.activateChange(1);
    this.setState({
      inputValue: e[0],
    });

    this.setState({
      inputValue2: e[1],
    });

   
    this.props.datadic.FilterDic.columns[this.myRef.current.props.id].selected ="1";
    this.props.datadic.FilterDic.columns[this.myRef.current.props.id].value = e;
 
    this.props.activateDatadic({ FilterDic: this.props.datadic.FilterDic }) ;
  
    setTimeout(() =>  this.HandleReqcount(), 1*1000);
   
    
    

  
  }

  enterClose(e) {
    this.props.activateChange(1);
  
    if (this.state.filtermt==0){
   
      this.props.activateFiname('');
    
      
    }
   this.props.datadic.FilterDic.columns[
     this.myRef.current.props.id
   ].selected = 0;
   this.props.datadic.FilterDic.columns[
     this.myRef.current.props.id
   ].selectedUI = 0;
   this.props.datadic.FilterDic.columns[
    this.myRef.current.props.id
  ].value = '';
 
   this.props.activateDatadic({ FilterDic: this.props.datadic.FilterDic });
    
   setTimeout(() =>  this.HandleReqcount(), 1*1000);
  }

  onChange = (e) => {
    this.props.activateChange(1);
  
   console.log(e)
    this.setState({
      inputValue: e,
    });
    this.props.datadic.FilterDic.columns[this.myRef.current.props.id].selected ="1";
    this.props.datadic.FilterDic.columns[this.myRef.current.props.id].value = [e,this.state.inputValue2];
    setTimeout(() =>  this.HandleReqcount(), 1*1000);
   

  };

  onChange2 = (e) => {
    this.props.activateChange(1);
   
    this.setState({
      inputValue2: e,
    });

    this.props.datadic.FilterDic.columns[this.myRef.current.props.id].selected ="1";
    this.props.datadic.FilterDic.columns[this.myRef.current.props.id].value = [this.state.inputValue,e];
    //this.props.activateDatadic({ FilterDic: this.props.datadic.FilterDic });
    setTimeout(() =>  this.HandleReqcount(), 1*1000);
  
  };

  componentDidMount() {
    if (Array.isArray(this.props.pass.value) == true) {
      this.setState({
        inputValue: this.props.pass.value[0],
        inputValue2: this.props.pass.value[1],
      });
    }



    


  }

  onDataUpdate = (data) => {
    this.setState(
      {
       
        lookingTickers: false,
      }   )
        this.props.activateRecord(data);
        
        this.props.activateScreen(false);
        this.props.activateGoing(false);
        
    
   
  }
  HandleReqcount() {
   
    this.props.activateScreen(true);
    
    const controller = new AbortController();
    
    const { signal } = controller;
    
   if (this.props.going==false) {
    
    
    var  requestOptions= '';
    this.props.activateScreen(true);
    if (this.props.univtype==1) {
    
       requestOptions = {
       method: "POST",
       headers: { "Content-Type": "application/json" },
       body: JSON.stringify({ tables: [this.props.datadic.FilterDic],  portfolioId : this.props.univid   }),
     };
   
    }
    
    if (this.props.univtype==2) {
       requestOptions = {
       method: "POST",
       headers: { "Content-Type": "application/json" },
       body: JSON.stringify({ tables: [this.props.datadic.FilterDic],  screenId : this.props.univid   }),
     };
   }
 
   if (this.props.univtype==0) {
     requestOptions = {
       method: "POST",
       headers: { "Content-Type": "application/json" },
       body: JSON.stringify({ tables: [this.props.datadic.FilterDic]    }),
     };
   }



    this.props.activateGoing(true);
    fetch(
      this.props.apppath + "/include/api/screener/ssfiltercount.cfm", 
      requestOptions
    )
      .then((response) => response.json())
      .then((data /*  this.props.activateStocks(data.filteredData ) */) =>
       this.onDataUpdate(data)
       
      )
      .then((data) => 1)
      .catch((error) => {
         
        this.props.activateScreen(false);
        this.props.activateGoing(false);
        this.setState(
          {
            lookingTickers: false,
          },
          () => {
            this.props.activateRecord("No Results");
          }
        );
      });
    }else{
     
     console.log(this.props.going)
    }
  }
  render() {
  
    const { inputValue, inputValue2,coltype } = this.state;
   
    console.log('CCCOOOOOOOOO',this.state.coltype)
 
    const slidestyle = {
      width: "100%",
    };
 
    const slidestyleHide = {
      display: "none",
    };
   
    const closebutton = {
    //  float: "right",
      paddingLeft:'60px',
    };

    const Switchbutton = {
      //  float: "right",
        paddingLeft:'100px',
        
      };
      const gridStyle = {
        //  float: "right",
        width: '100%',
     
          
        };

        console.log('GGGGGGGGGGGGGGGGGGGGGGGGGGGGGGG',this.state.pass.minString)
    let mymax = this.state.pass.max;
    const marks = {
      [this.state.pass.min]:this.state.pass.minString!='' &&  this.state.pass.minString!=undefined?this.state.pass.minString.includes('(')==true? <span style={{color:'red'}} >{this.state.pass.minString}</span>:this.state.pass.minString:'' ,

      [this.state.pass.max]: this.state.pass.maxString,
    };

    /* if (this.state.inputValue==0 && this.state.inputValue2==0){
      this.setState({
        inputValue:this.state.pass.min,
        inputValue2:this.state.pass.max,
      });
    } */
    return (
      <div   >
        <Card>
        <Card.Grid style={gridStyle} className='movercard'>
          <div className="sliderpa">
          <Popover content={this.state.pass.definition} title={this.state.pass.label} placement="right">
          {this.state.pass.label}
          </Popover>
          {" "}
          <Row
            gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}
             
            align="middle"
          >
            <Col span={24}>
              {" "}
              <div className="sliderchild input1">
              <InputNumber
                onChange={this.onChange}
                value={inputValue}
                min={this.state.pass.min}
                max={this.state.pass.max}
              />
         </div>
         <div className="sliderchild chislider2">
              <Slider
                defaultValue={
                  Array.isArray(this.props.pass.value) == false
                    ? [this.state.pass.min,this.state.pass.max]
                    : [this.state.inputValue, this.state.inputValue2]
                }
                value={
                  Array.isArray(this.props.pass.value) == true
                    ? this.props.pass.value
                    : [this.state.inputValue, this.state.inputValue2]
                }
                range
                marks={marks}
                min={this.state.pass.min}
                max={this.state.pass.max}
                id={this.state.id}
                onChange={this.handleChange}
                ref={this.myRef}
              ></Slider>{" "}
         </div>
         
              {" "}
              <div className="sliderchild input2">
              <InputNumber
                onChange={this.onChange2}
                value={inputValue2}
                min={this.state.pass.min}
                max={this.state.pass.max}
              />
                  </div>
              <div  className="sliderchild chiswitch">
               {coltype=='percentile'?
                <Switch checkedChildren="% Rank" unCheckedChildren="Absolute" defaultChecked className='per'    id={this.state.id}  onChange={(e) => this.handleToggle(this.state.colNameId, e,this.state.id)} />
                :
                <Switch checkedChildren="% Rank" unCheckedChildren="Absolute"    className='abs'    id={this.state.id}  onChange={(e) => this.handleToggle(this.state.colNameId, e,this.state.id,[this.state.pass.min,this.state.pass.max])} />
              }
                </div>
        
        
              {" "}
              <div  className="sliderchild chibutton">
                {" "}
                <Tooltip placement="topLeft" title="Remove this filter" color={'#2db7f5'}>
                <Button
                  type="text"
                  icon={<CloseCircleTwoTone />}
                  onClick={() => this.enterClose(this.state.id)}
                ></Button></Tooltip>{" "}
              </div>{" "}
            
    <br />
            </Col>
          </Row></div>
          </Card.Grid>
        </Card>
      </div>
    );
  }
}
 

const mapStateToProps = (state) => ({
  datadic: state.datadic,
  datadicbackup: state.datadicbackup,
  finame: state.finame,
  change: state.change,
  screen: state.screen,
  record: state.record,
  apppath: state.apppath,
  going: state.going,
  univid: state.univid,
  univtype: state.univtype,
});

const mapDispatchToProps = {
  activateDatadic,activateDatadicbackup,activateFiname,activateChange,activateScreen,activateRecord,activatePath, activateGoing, activateUnivid,
  activateUnivtype,
};

const Sliderlo = connect(mapStateToProps, mapDispatchToProps)(Sliderloclass);

export default Sliderlo;

 